// React
import { Fragment } from "react"

// Components
import { ActionButton, Button, Input, Modal } from "components"

// Utils
import { useApi, useToggle } from "utils"
import { PERMISION } from "security"
import toast from "react-hot-toast"
import { ErrorFetch, SuccessFetch } from "types"

export function DeleteBill(params: {
  item: DetailDeleteType
  onSuccess: () => void
}) {
  // Hooks
  const { isActive, toggle } = useToggle(false)

  return (
    <Fragment>
      <ActionButton.Delete
        permission={
          PERMISION.PURCHASES.REGISTER.BY_DATE_RANGE.DELETE || 
          PERMISION.PURCHASES.REGISTER.BY_CARD.DELETE || 
          PERMISION.PURCHASES.REGISTER.BY_LOCATION.DELETE ||
          PERMISION.PURCHASES.REGISTER.BY_REFERENCE_ID.DELETE ||
          PERMISION.PURCHASES.REGISTER.BILLS_ITEM.DELETE
        }
        className="text-error"
        onClick={toggle}
      />

      {isActive && (
        <DeleteModal
          onSuccess={params.onSuccess}
          toggle={toggle}
          item={{
            bill_id: params.item.bill_id!.toString(),
            transaction_date: params.item.transaction_date,
            trx_code: params.item.trx_code,
            vendor_name: params.item.vendor_name
          }}
        />
      )}
    </Fragment>
  )
}

// Components
interface DetailDeleteType {
  bill_id?: string
  transaction_date: string
  trx_code: string
  vendor_name: string
}


export function DeleteModal(params: {
  item: DetailDeleteType
  onSuccess: () => void
  toggle: () => void
}) {
  // Hooks
  const api = useApi()
  const { isActive, setActive } = useToggle(false)

  const onDelete = (): void => {
    setActive(true)

    toast.promise(
      api.delete(`/probill/deletebill?bill_id=${params.item.bill_id}`),
      {
        loading: "Loading...",
        success: (res: SuccessFetch<{ message: string }>) => res.data.message,
        error: (err: ErrorFetch<{ message: string }>) => err.response.data.message
      }
    ).then(() => {
      params.toggle()
      params.onSuccess()
    }).catch(() => {
    }).finally(() => {
      setActive(false)
    })
  }

  return (
    <Modal
      isOpen
      title="DELETE BILL"
      closeModal={params.toggle}
    >
      <Modal.Body className="flex flex-col gap-3">
        <div className="text-error">Are you sure want to delete this data?</div>

        <Input
          disabled
          label="BILL ID#"
          value={params.item.trx_code}
        />

        <Input
          disabled
          label="DATE"
          value={params.item.transaction_date}
        />

        <Input
          disabled
          label="VENDOR"
          value={params.item.vendor_name}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button
          type="button"
          color="error"
          loading={isActive ? "true" : undefined}
          onClick={onDelete}
          permission={"PR014"}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  )
}